import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from '@/utils';
import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
export default {
  name: 'banner_service_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tabListFlat: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      channel_service_hotline: '',
      rules: {
        image: [{
          required: true,
          message: '图片不可为空'
        }],
        service_hotline_source: [{
          required: true,
          message: '请选择客服电话来源',
          trigger: 'change'
        }],
        service_hotline: [{
          required: true,
          message: '请输入客服电话',
          trigger: 'change'
        }, {
          pattern: /^[0-9]+-?[0-9]*$/,
          message: '请输入正确的号码',
          trigger: 'change'
        }]
      },
      showPictureLibrary: false,
      depot: {},
      pictureList: []
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config['image'] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture() {
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload() {
      this.$refs.uploadBanner.uploadBanner();
    },
    emitUploadFile: function emitUploadFile(image) {
      this.$set(this.value.config, 'image', "".concat(this.$ossurl).concat(image));
    },
    deleteImg: function deleteImg() {
      var _this2 = this;
      if (!this.value.config.image) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this2.value.config.image = '';
      });
    }
  },
  created: function created() {
    var _this3 = this;
    var _ref = this.tabListFlat.find(function (i) {
        return i.key === _this3.value.key;
      }) || {},
      _ref$config_default_v = _ref.config_default_value,
      config_default_value = _ref$config_default_v === void 0 ? {} : _ref$config_default_v;
    var defaultValue = JSON.parse(JSON.stringify(config_default_value));
    this.channel_service_hotline = defaultValue.channel_service_hotline;
    delete defaultValue.channel_service_hotline;
    if (isEmpty(this.value.config)) {
      this.$set(this.value, 'config', _objectSpread({}, defaultValue));
    }
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index //兼容新老组件 默认预置2
    }));
    this.getPicture();
  }
};